import React from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { Location } from "../types";
import { formatFullAddress } from "../utils/formatFullAddress";

interface LocationItemProps {
  location: Location;
  isDiner?: boolean;
  hideAddress?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Header = styled.div<{ isDiner?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  color: ${({ isDiner }) => (isDiner ? "#FFF" : undefined)};
`;

const Icon = styled.span<{ isDiner?: boolean }>`
  color: ${({ isDiner }) => (isDiner ? "#FFF" : "#afabab")};
  font-size: 14px;
  display: flex;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const Name = styled.span<{ isDiner?: boolean }>`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-weight: 500;
  color: ${({ isDiner }) => (isDiner ? "#FFF" : "#000")};
  font-size: 14px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const Address = styled.span<{ isDiner?: boolean }>`
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-weight: 400;
  color: ${({ isDiner }) => (isDiner ? "#FFF" : "#000")};
  font-size: 12px;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const AddressRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-left: 15px;
`;

const LocationItem: React.FC<LocationItemProps> = ({
  location,
  isDiner,
  hideAddress = false,
}) => {
  const { name, address, city, state, zip_code } = location;
  const fullAddress = formatFullAddress(address, city, state, zip_code);
  return (
    <Container>
      <Header isDiner={isDiner}>
        <Icon isDiner={isDiner}>
          <FontAwesomeIcon
            icon={faLocationDot}
            fontSize={14}
            color={isDiner ? "#FFF" : "#afabab"}
          />
        </Icon>
        <Name isDiner={isDiner}>{name}</Name>
      </Header>
      {!hideAddress && (
        <AddressRow>
          <Address isDiner={isDiner}>{fullAddress}</Address>
        </AddressRow>
      )}
    </Container>
  );
};

export default LocationItem;
